import { QueryBuilder } from '@modules/queryBuilder/components/QueryBuilder';
import { FilterAltRounded } from '@mui/icons-material';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { WhereClause } from 'v2/core/services/queryBuilder/whereClause';

interface CustomFilterModalEditQueryProps {
  whereClause?: WhereClause;
}

export const CustomFilterModalEditQuery = ({
  whereClause,
}: CustomFilterModalEditQueryProps) => {
  return (
    <Box component={Paper} p={1}>
      <Stack spacing={0.5} alignItems="center" direction="row" mb={0.5}>
        <FilterAltRounded
          sx={{
            fontSize: 'inherit',
            color: 'text.secondary',
          }}
        />
        <Typography variant="body2" color="text.secondary">
          Contains these filters
        </Typography>
      </Stack>
      <QueryBuilder
        whereClause={whereClause}
        openOnFocus={false}
        shouldSkipWarningMessage
        actionsProps={{
          shouldRenderExecuteButton: false,
        }}
        footerProps={{
          shouldRenderCreateNewFilter: false,
        }}
      />
    </Box>
  );
};
